import { useState, type ReactNode } from 'react'
import { Trophy, type LucideIcon } from 'lucide-react'

interface BroadcastHeaderProps {
  title: string
  competition?: string
  matchday?: { current: number; total: number }
  trophySrc?: string
  /** Emblem shown when there is no trophy image (defaults to a trophy) */
  icon?: LucideIcon
  meta?: ReactNode
  action?: ReactNode
}

// Scenography header: banner gradient + net mesh texture, gold baseline
// strip and an emblem on a dark TV stage — an AI trophy for competitions,
// or a themed Lucide icon for management screens.
export function BroadcastHeader({ title, competition, matchday, trophySrc, icon, meta, action }: BroadcastHeaderProps) {
  const [trophyOk, setTrophyOk] = useState(true)
  const Emblem = icon ?? Trophy

  return (
    <header className="broadcast-header tx-net">
      <div className="broadcast-header-trophy">
        {trophySrc && trophyOk ? (
          <img src={trophySrc} alt="" onError={() => setTrophyOk(false)} />
        ) : (
          <Emblem size={30} />
        )}
      </div>
      <div className="broadcast-header-body">
        {(competition || matchday) && (
          <div className="broadcast-header-kicker">
            {competition}
            {matchday && (
              <span className="chip-angled tone-gold">
                J{matchday.current}/{matchday.total}
              </span>
            )}
          </div>
        )}
        <h2 className="broadcast-header-title">{title}</h2>
        {meta && <div className="broadcast-header-meta">{meta}</div>}
      </div>
      {action && <div style={{ position: 'relative', flex: 'none' }}>{action}</div>}
    </header>
  )
}
